var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.2981,
    fill: "#F1EFFF",
    stroke: "#353255",
    strokeWidth: 0.403841
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2103 6.96582H6.78966C6.30177 6.96582 5.90625 7.36134 5.90625 7.84923V13.1497C5.90625 13.6376 6.30177 14.0331 6.78966 14.0331H14.2103C14.6982 14.0331 15.0938 13.6376 15.0938 13.1497V7.84923C15.0938 7.36134 14.6982 6.96582 14.2103 6.96582Z",
    stroke: "#363157",
    strokeWidth: 0.706723,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.31641 8.37891L10.4967 10.8525L13.677 8.37891",
    stroke: "#363157",
    strokeWidth: 0.706723,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/MailIcon.12116e2a95dba9b80aa0bb1fe2d5619b.svg";
export { ForwardRef as ReactComponent };